/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExecutionSystemActionType = {
    Execute: 'execute',
    Read: 'read'
} as const;
export type ExecutionSystemActionType = typeof ExecutionSystemActionType[keyof typeof ExecutionSystemActionType];


export function instanceOfExecutionSystemActionType(value: any): boolean {
    for (const key in ExecutionSystemActionType) {
        if (Object.prototype.hasOwnProperty.call(ExecutionSystemActionType, key)) {
            if (ExecutionSystemActionType[key as keyof typeof ExecutionSystemActionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExecutionSystemActionTypeFromJSON(json: any): ExecutionSystemActionType {
    return ExecutionSystemActionTypeFromJSONTyped(json, false);
}

export function ExecutionSystemActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionSystemActionType {
    return json as ExecutionSystemActionType;
}

export function ExecutionSystemActionTypeToJSON(value?: ExecutionSystemActionType | null): any {
    return value as any;
}

export function ExecutionSystemActionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ExecutionSystemActionType {
    return value as ExecutionSystemActionType;
}

